import { render } from "./IframeViewComponent.vue?vue&type=template&id=56c1c39a"
import script from "./IframeViewComponent.vue?vue&type=script&lang=js"
export * from "./IframeViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__